import AppSettingsProvider from '%app/js/common/services/AppSettingsProvider';

const SUPPORTED_CURRENCIES = environment_config.supported_currencies;
const GOOGLE_MAPS_API_KEY = (new AppSettingsProvider()).getAppSettings().getGooglePlacesApiKey();
const FORM_NAME = 'event-form';
const DRAWER_TOP_OFFSET_MULTIPLIER = 17;
const CONTENT_TOP_OFFSET_MULTIPLIER = DRAWER_TOP_OFFSET_MULTIPLIER - 5;
const HEADER_SCROLL_OFFSET = -150;

export {
    SUPPORTED_CURRENCIES,
    GOOGLE_MAPS_API_KEY,
    FORM_NAME,
    DRAWER_TOP_OFFSET_MULTIPLIER,
    CONTENT_TOP_OFFSET_MULTIPLIER,
    HEADER_SCROLL_OFFSET,
};
